export interface ILanguage {
    DefaultLanguage: boolean,
    Lcid: number,
    Name: string,
    DataType: string,
    id: string
    Code: string;
}

export interface ITranslations {
    [key: string]: ISingleTranslate[];
}

export interface ISingleLcidTranslations {
    [key: string]: string;
}

export interface ISingleTranslate {
    Label: string;
    [langKey: string]: string
}

export interface IWorkspaceTranslations {
    [key: string]: ISingleWorkspaceTranslate[];
}

export interface ISingleWorkspaceTranslate {
    Label: string;
    type?: ELanguageType;
    [langKey: string]: string;
}

export interface IUpdateTranslation {
    label: string;
    translations: {
        [key: string]: string
    }
}

export enum ELcid {
    Label = -2,
    None = -1,
    All = 0,
    En = 1033,
    Es = 1034,
    Fr = 1036,
    Pt = 1046,
    Ru = 1049,
    Uk = 1058,
    De = 1031,
    Pl = 1045,
    Nl = 2067,
    It = 1040,
    Ms = 1086,
    Vi = 1066,
    Hr = 1050,
    Hu = 1038,
    Sk = 1051,
    Sl = 1060,
    Ar = 1401,
    Ro = 1048,
    Fil = 1124,
    Th = 30,
    Da = 1030,
    Fi = 1035,
    Id = 1057,
    Ja = 1041,
    Tr = 1055,
    Zh = 2052,
    Cz = 1029
}

export enum ELcidFromCode {
    'en' = 1033,
    'es' = 1034,
    'fr' = 1036,
    'pt' = 1046,
    'ru' = 1049,
    'uk' = 1058,
    'de' = 1031,
    'pl' = 1045,
    'nl' = 2067,
    'it' = 1040,
    'ms' = 1086,
    'vi' = 1066,
    'hr' = 1050,
    'hu' = 1038,
    'sk' = 1051,
    'sl' = 1060,
    'ar' = 1401,
    'ro' = 1048,
    'fil' = 1124,
    'th' = 30,
    'da' = 1030,
    'fi' = 1035,
    'id' = 1057,
    'ja' = 1041,
    'tr' = 1055,
    'zh' = 2052,
    'cz' = 1029
}

export enum ELangCode {
    En = 'en',
    Fr = 'fr',
    Es = 'es',
    Pt = 'pt',
    Ru = 'ru',
    Uk = 'uk',
    De = 'de',
    Pl = 'pl',
    It = 'it',
    Nl = 'nl',
    Ms = 'ms',
    Vi = 'vi',
    Hr = 'hr',
    Hu = 'hu',
    Sk = 'sk',
    Sl = 'sl',
    Ar = 'ar',
    Ro = 'ro',
    Fil = 'fil',
    Th = 'th',
    Da = 'da',
    Fi = 'fi',
    Id = 'id',
    Ja = 'ja',
    Tr = 'tr',
    Zh = 'zh',
    Cz = 'cz'
}

export interface IClusterMessageTranslation {
    ConversationCreated: string;
    ConversationTitleChanged: string;
    DocumentRemoved: string;
    MemberAdded: string;
    MemberJoined: string;
    MemberLeft: string;
    MemberRemoved: string;
    MessageRemoved: string;
    MessageRemovedBySender: string;
    OwnerDeclared: string;
    OwnerStatusRevoked: string;
    RemovingMultipleVirtualFileSystem: string;
    RemovingVirtualFileSystem: string;
    UploadingMultipleVirtualFileSystem: string;
    UploadingVirtualFileSystem: string;
    UserLeftConversation: string;
    UserLeftConversationNamedNewOwner: string;
    UserRemovedFromConversation: string;
}

export enum ELanguageType {
    Global = 'Global',
    Local = 'Local'
}